import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import UA from 'drip/ua';
import KNB from '@dp/knb';

// knb方法内的console保留方便排查线上问题
export function notifyCalendar(obj) {
  console.log('obj', obj);
  if (obj.start) {
    obj.start = Number(obj.start);
  }
  console.log('10*60*1000<', obj.start - Date.now());
  if ((obj.start && obj.start - Date.now()) > 10 * 60 * 1000) {
    return new Promise(function (resolve) {
      KNB.setupEvent({
        sceneToken: 'my-87bff41fea170162',
        title: obj.title,
        //String 类型，日历标题
        start: obj.start,
        //Number 类型, 开始时间， 毫秒时间戳
        duration: 60,
        //Number 类型，持续时间，单位秒，默认时间 1.5h
        alarm: -600,
        //Number 类型，自开始时间起过多少秒的闹铃，可填负数，表明提前 start 的闹铃时间
        success: function success() {
          resolve(true);
        },
        fail: function fail(e) {
          console.log('calendarErr', e);
          resolve(false);
        }
      });
    });
  } else {
    return false;
  }
}